import * as React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { alpha } from '@mui/material/styles';
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
    Toolbar,
    Typography,
    Paper,
    Checkbox,
    IconButton,
    Tooltip
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { visuallyHidden } from '@mui/utils';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import { Button, CircularProgress, Dialog, DialogActions, DialogTitle } from '@mui/material';
import BuyOnlineModal from './BuyOnlineModal';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import noImage from '../asset/images/no Image_av.png';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import {headCells} from '../utils/Constants';

function createData(id, name, calories, fat, carbs, protein) {
    return {
        id,
        name,
        calories,
        fat,
        carbs,
        protein,
    };
}



function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array?.map((el, index) => [el, index]);
    stabilizedThis?.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}



function EnhancedTableHead(props) {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort, disableSorting, showOnlineBuy } =
        props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                <TableCell padding="checkbox">
                    <Checkbox
                        color="primary"
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{
                            'aria-label': 'select all desserts',
                        }}
                    />
                </TableCell>
                {headCells.map((headCell) => (headCell.id === "action" && !showOnlineBuy) ? <></> : <TableCell
                    key={headCell.id}
                    align={headCell.numeric ? 'center' : 'left'}
                    padding={headCell.disablePadding ? 'none' : 'normal'}
                    sortDirection={orderBy === headCell.id ? order : false}
                >
                    {disableSorting.includes(headCell.id) ? ( // Check if sorting is disabled for this column
                        <Typography variant="subtitle1">{headCell.label}</Typography>
                    ) : (
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    )}
                </TableCell>)}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
    disableSorting: PropTypes.arrayOf(PropTypes.string)
};

function EnhancedTableToolbar(props) {
    const { numSelected, selectedProjectName, setOpenDeleteDialogForItem, selected,setItemPasteState,handleCopyItem,handlePasteItem,itemPasteState } = props;

    return (
        <Toolbar
        className='Table_head'
            sx={{
                pl: { sm: 2 },
                pr: { xs: 1, sm: 1 },
                ...(numSelected > 0 && {
                    bgcolor: (theme) =>
                        alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
                }),
            }}
        >
            {numSelected > 0 ? (
                <Typography
                    sx={{ flex: '1 1 100%' }}
                    color="inherit"
                    variant="subtitle1"
                    component="div"
                >
                    {numSelected} selected
                </Typography>
            ) : (
                <Typography
                    sx={{ flex: '1 1 100%' }}
                    variant="h6"
                    id="tableTitle"
                    component="div"
                >
                    {selectedProjectName}
                </Typography>
            )}
            <Tooltip title="Paste">
                    <IconButton disabled={itemPasteState.length   >0?false:true}>
                        <ContentPasteIcon onClick={() => handlePasteItem()} />
                    </IconButton>
                </Tooltip>
            {numSelected > 0 ? (
                <>
                <Tooltip title="Copy">
                    <IconButton>
                        <ContentCopyIcon onClick={() => {handleCopyItem(selected) }} />
                      
                    </IconButton>
                </Tooltip>
                <Tooltip title="Delete">
                    <IconButton>
                        <DeleteIcon onClick={() => { setOpenDeleteDialogForItem(true) }} />
                    </IconButton>
                </Tooltip>
                </>
            ) : (
                <>
                </>
            )}
        </Toolbar>
    );
}

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

export default function LandingPgaeTable({ rows, selectedProjectName, handleIncrease, handleDecrease, handleDeletefromTable,setItemPasteState,itemPasteState,setHandleFlag,handlePasteItem,showOnlineBuy }) {
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('catalog');
    const [selected, setSelected] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [dense, setDense] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [productDetailData, setProductDetailData] = React.useState([]);
    const [catalogNo, SetCatalogNo] = React.useState([]);
    const [preparedData, SetPreparedData] = React.useState([]);
    const [open, setOpne] = React.useState(false);
    const [pageLoader, setPageLoader] = React.useState(false);
    const [openDeleteDialogForItem, setOpenDeleteDialogForItem] = React.useState(false);

   

    React.useEffect(() => {
        setPageLoader(true)
        if (rows.length > 0) {
            
            var getCatalogNo = []
            rows.forEach(element => {
                getCatalogNo.push(element.catalogNo)
            });
            SetCatalogNo(getCatalogNo)
        }else{
            handleLoader()
        }
    }, [rows])
    React.useEffect(() => {
        if (showOnlineBuy) {
            const fetchdata = async () => {
                const getdata = await axios.all(catalogNo.map((endpoint) => axios.get(`https://api.channelsight.com/api/1.22/feed?key=849fcecd-306f-41c0-b423-5670a82d9777&assetId=814&pid=${endpoint}`))).then(
                    (data) => data
                );
                if (getdata.length > 0) {
                    var appendData = []
                    getdata.forEach(element => {
                        if (element?.data[0]?.RetailerProducts?.length > 0) {
                            appendData.push(element?.data[0]?.ProductId)
                        }

                    });
                    SetPreparedData(appendData)
                    handleLoader()
                }
            }
            fetchdata()
        } else {
            handleLoader()
        }
        handleLoader()

    }, [catalogNo])

    const handleLoader = () => {
        setTimeout(() => {
            setPageLoader(false)
        }, 500);
    }



    React.useEffect(() => {
        if (rows?.length > 0) {
            rows.map((item) => createData(item.catalogNo, item.dataSheetUrl, item.pictureUrl, item.description, item.retailerProduct))
        }
        setSelected([])
    }, [rows, selectedProjectName])

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleCopyItem = (value) => {
        setHandleFlag(true)
        let PreparedItem = []
        rows.forEach(element => {
            if(value.includes(element.catalogNo)){
                PreparedItem.push(element)
            }
        });
        setItemPasteState([...PreparedItem])
    }



    const handleClick = (event, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleChangeDense = (event) => {
        setDense(event.target.checked);
    };

    const isSelected = (id) => selected.indexOf(id) !== -1;

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
           
            const newSelected = rows.map((n) => n.catalogNo);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows?.length) : 0;


    const visibleRows = React.useMemo(
        () =>
            stableSort(rows, getComparator(order, orderBy)).slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage,
            ),
        [order, orderBy, page, rowsPerPage, rows, selectedProjectName],
    );

    const disableSortingColumns = ['quantity', 'datasheet', 'catalog', 'image', 'description', "action"]; // Specify the columns for which sorting should be disabled

    const handleBuyOnline = async (catalogNo) => {
        try {
            const response = await fetch(`https://api.channelsight.com/api/1.22/feed?key=849fcecd-306f-41c0-b423-5670a82d9777&assetId=814&pid=${catalogNo}`);
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            } else {
                const result = await response.json();
                setProductDetailData(result[0]);
                setOpne(true)
            }
        } catch (error) {
            //   setError(error.message);
            console.log(error);
        }
    }

    const handlefindreseller = () => {
        window.open("https://www.se.com/us/en/work/support/locator/");
    }
    const handleDeleteItem = () => {
        handleDeletefromTable(selected)
        setOpenDeleteDialogForItem(false)
    }

    return (
        <>
            <Box sx={{ width: '100%' }}>
                <Paper sx={{ width: '100%', mb: 2 }}>
                    <EnhancedTableToolbar numSelected={selected.length} selectedProjectName={selectedProjectName} setOpenDeleteDialogForItem={setOpenDeleteDialogForItem} selected={selected} setItemPasteState={setItemPasteState} handleCopyItem={handleCopyItem} handlePasteItem={handlePasteItem} itemPasteState={itemPasteState}/>
                    <TableContainer>
                        <Table
                            sx={{ minWidth: 750 }}
                            aria-labelledby="tableTitle"
                            size={dense ? 'small' : 'medium'}
                        >
                            <EnhancedTableHead
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={handleSelectAllClick}
                                onRequestSort={handleRequestSort}
                                rowCount={rows.length}
                                disableSorting={disableSortingColumns}
                                showOnlineBuy={showOnlineBuy}
                            />
                            <TableBody>
                                {visibleRows.length>0 ? rows && visibleRows.map((row, index) => {
                                    const isItemSelected = isSelected(row.catalogNo);
                                    const labelId = `enhanced-table-checkbox-${index}`;
                                    return (
                                        row && <TableRow
                                            hover
                                            role="checkbox"
                                            aria-checked={isItemSelected}
                                            tabIndex={-1}
                                            key={row.catalogNo}
                                            selected={isItemSelected}
                                            sx={{ cursor: 'pointer' }}
                                        >
                                            <TableCell padding="checkbox">
                                                <Checkbox
                                                    onClick={(event) => handleClick(row, row.catalogNo)}
                                                    color="primary"
                                                    checked={isItemSelected}
                                                    inputProps={{
                                                        'aria-labelledby': labelId,
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                scope="row"
                                                padding="none"
                                            >
                                                <div className='catalog_box'>
                                                    <div className='quntity_box'>
                                                        <Button onClick={() => handleDecrease(index, page, rowsPerPage)} disabled={row.quantity === 1 ? true : false} ><RemoveIcon /></Button>
                                                        <strong>{row.quantity}</strong>
                                                        <Button onClick={() => handleIncrease(index, page, rowsPerPage)}><AddIcon /></Button>
                                                    </div>
                                                </div>
                                            </TableCell>
                                            <TableCell align="center">
                                                <img className='ProductImg' src={row.pictureUrl ? row.pictureUrl : noImage} alt={"Picture Url"} />
                                            </TableCell>
                                            
                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                scope="row"
                                                padding="none"
                                            >
                                                <div className='catalog_box'>
                                                    <div className='catalog_details'>
                                                        <span className='catalog_number' >{row.catalogNo}</span>
                                                    </div>
                                                </div>
                                            </TableCell>
                                            <TableCell align="center" className='catalog_description'>{row.description}</TableCell>
                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                scope="row"
                                                padding="none"
                                            >
                                                <div className='catalog_box'>
                                                    <div className='catalog_details'>
                                                        <a className='catalog_datasheet' href={`https://eref.se.com/us/en/scope/product/${row.catalogNo}`} target="_blank" >Datasheet</a>
                                                    </div>
                                                </div>
                                            </TableCell>
                                            {showOnlineBuy &&
                                                <TableCell align="center">
                                                    {preparedData.includes(row.catalogNo) ? <Button className="buyonlineButton" onClick={() => handleBuyOnline(row.catalogNo)}>{`Buy Online`}</Button> : <Button className="buyonlineButton" onClick={() => handlefindreseller()}>{`Find Seller`}</Button>}

                                                </TableCell>}
                                        </TableRow>
                                    );
                                }) : <TableRow className='No_Data_cell'>
                                <TableCell colSpan={showOnlineBuy ? 7 :6}><p>This material list is empty... select the Add Item button above to add parts to this list</p></TableCell>
                              </TableRow>}
                                {emptyRows > 0 && (
                                    <TableRow
                                        style={{
                                            height: (dense ? 33 : 53) * emptyRows,
                                        }}
                                    >
                                        <TableCell colSpan={6} />
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={rows.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Paper>
                {open && <BuyOnlineModal open={open} setOpne={setOpne} productDetailData={productDetailData} />}
            </Box>
            {pageLoader && <div className="loader_div">
                <CircularProgress disableShrink />{" "}
            </div>}
            <Dialog
        open={openDeleteDialogForItem}
        onClose={()=>setOpenDeleteDialogForItem(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="delete_content"
      >
        <DialogTitle id="alert-dialog-title">{`Are you sure that you want to permanently delete the selected ${selected.length>1 ? "items" :"item"}?`}</DialogTitle>
        <DialogActions className="project_modal">
          <Button variant="contained" onClick={() => handleDeleteItem()} autoFocus>
            Delete
          </Button>
          <Button variant="contained" onClick={() => setOpenDeleteDialogForItem(false)()}>Cancel</Button>
        </DialogActions>
      </Dialog>
        </>
    );
}
